import { QueryKey, UseQueryOptions, useQuery } from 'react-query';

import { getResourceProjectCategories } from 'services/resources';

export default function useProjectCategories(
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    [`project-categories`],
    () =>
      getResourceProjectCategories().then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError.message);
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
